import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DeleteAttachmentMutation from '../../../../../mutations/ticketing/tickets/deleteAttachmentMutation';

interface UseDeleteAttachmentResult {
	submit: (id: string) => Promise<void>;
	loading: boolean;
	error: string | null;
}

export function useDeleteAttachment(): UseDeleteAttachmentResult {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(id: string): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				DeleteAttachmentMutation,
				{id},
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
